import angular from 'angular'
import ngFileUpload from 'ng-file-upload'
// The main app uses UI Bootstrap components
import accordion from 'ui-bootstrap4/src/accordion'
import alert from 'ui-bootstrap4/src/alert'
import buttons from 'ui-bootstrap4/src/buttons'
import collapse from 'ui-bootstrap4/src/collapse'
import dropdown from 'ui-bootstrap4/src/dropdown'
import modal from 'ui-bootstrap4/src/modal'
import pagination from 'ui-bootstrap4/src/pagination'
import popover from 'ui-bootstrap4/src/popover'
import progressbar from 'ui-bootstrap4/src/progressbar'
import rating from 'ui-bootstrap4/src/rating'
import tabs from 'ui-bootstrap4/src/tabs'
import timepicker from 'ui-bootstrap4/src/timepicker'
import tooltip from 'ui-bootstrap4/src/tooltip'
import 'ui-cropper'
import 'ui-cropper/compile/minified/ui-cropper.css'
import 'ui-select'
import 'ui-select/dist/select.css'
// Inherit from module that has generic independent components.
import { CommonModule } from '../../common/common.module'
import { EditAddressComponent } from './address/edit-address.component'
import { ChooseWorksheetsModalComponent } from './choose-worksheets-modal/choose-worksheets-modal.component'
import { SupportContactInfoComponent } from './contact-info/support-contact-info.component'
import { UnbindKendoDirective } from './directives/unbind-kendo.directive'
import { ErrorsModule } from './errors/errors.module'
import { FeatureToggleModule } from './feature-toggle/feature-toggle.module'
import { FeedbackModule } from './feedback/feedback.module'
import { ImageCropperModalComponent } from './image-cropper/image-cropper-modal.component'
import { LayoutModule } from './layout/layout.module'
import { LocaleSwitcherComponent } from './locale-switcher/locale-switcher.component'
import { MaskedStaticTextModule } from './masking/masking.module'
import { MobileAppLinksComponent } from './mobile-app-links/mobile-app-links.component'
import { ModelStateErrorsComponent } from './model-state-errors/model-state-errors.component'
import { NavModule } from './nav-sidebar/nav.module'
import { EditPhoneComponent } from './phone/edit-phone.component'
import { SchedulerModule } from './scheduler/scheduler.module'


/** A module containing shared components, which should be imported wherever these components are needed. */
export const SharedModule = angular
    .module("apex.mainApp.shared", [
        'chart.js',
        'kendo.directives', // Required from vendor list

        // TODO: Include components in modules as needed to facilitate lazy loading.
        accordion,
        alert,
        buttons,
        collapse,
        dropdown,
        modal,
        pagination,
        popover,
        progressbar,
        rating,
        tabs,
        timepicker,
        tooltip,
        'ui.select',
        'uiCropper',
        //TODO: replace any remaining references with apex-file-model, which has enhanced functionality.
        "file-model", // Required from vendor listings, so no need to import again.
        ngFileUpload,

        // Include all components from the common module
        CommonModule,
        ErrorsModule,
        FeatureToggleModule,
        FeedbackModule,
        LayoutModule,
        MaskedStaticTextModule,
        NavModule,
        SchedulerModule
    ])
    .component("apexEditAddress", EditAddressComponent)
    .component("apexImageCropperModal", ImageCropperModalComponent)
    .component("apexChooseWorksheetsModal", ChooseWorksheetsModalComponent)
    .component("apexEditPhone", EditPhoneComponent)
    .component("apexLocaleSwitcher", LocaleSwitcherComponent)
    .component("apexModelStateErrors", ModelStateErrorsComponent)
    .component("apexMobileAppLinks", MobileAppLinksComponent)
    .component("apexSupportContactInfo", SupportContactInfoComponent)
    .directive("apexUnbindKendo", UnbindKendoDirective)
    .name;
